// extracted by mini-css-extract-plugin
module.exports = {"view-content-column":"styles__view-content-column__1L9BF","viewContentColumn":"styles__view-content-column__1L9BF"};